const tableMessages = {
    openFilters: ['table>>openFilters', 'Pokaż filtry'],
    closeFilters: ['table>>closeFilters', 'Ukryj filtry'],
    applyFilters: ['table>>applyFilters', 'Zastosuj filtry'],
}

export default tableMessages
